import { Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export default function CtaContent() {

    return (
        <Grid size={{ xs: 12, md: 6 }}>
            <Typography variant="h2">Tenha acesso à nossa área exclusiva para empresas</Typography>
            <Typography my={'1.5rem'}>Gostaria de ser um parceiro Inovart Gold?
                Tenha um catálogo prórpio, faça pedido de joias customizadas para seus clientes, receba novidades em primeira mão e muito mais!</Typography>

            <Button component={Link} to="https://wa.me/5551995760457?text=Olá! Estou vindo do site e gostaria de conhecer a Inovart Gold!" variant="contained" size="large" target="_blank" rel="noopener noreferrer" color="secondary">
                Converse com nossos especialistas
            </Button>
        </Grid>
    );
};